export default class CreateResultsTransferCtrl {

  constructor ($scope, $timeout, $mdDialog, $cookies, WorkPlanSrv, WorkPlanModalSrv, $stateParams, WorkPlanIndicatorSrv, GlobalConfig) {
    var createTransferVm = this
    const texts = GlobalConfig.appTexts
    const currentUser = JSON.parse($cookies.get('currentUser'))
    let post = {
      workplanId: currentUser.workplanId,
      teacherId: currentUser.teacherId
    }

     // VARIABLES
    createTransferVm.isEditing = Boolean($stateParams.workplanTeacherActivityId)
    createTransferVm.rangeType = GlobalConfig.periods.rangeType
    createTransferVm.workplanTeacherActivityId = null
    createTransferVm.createOrEdit = 'Crear'
    createTransferVm.textCreateOrEdit = texts.saved
    createTransferVm.createOrEditMV = texts.createDialog
    createTransferVm.typePeriod = []
    createTransferVm.periodsArray = []
    createTransferVm.notification = GlobalConfig.generals.notActive
    createTransferVm.selectedTypePeriod = {}
    createTransferVm.isTouchedPeriods = false
    createTransferVm.startDate = null
    createTransferVm.endDate = null
    createTransferVm.minStartDate = moment().toDate()
    createTransferVm.minEndDate = new Date()
    createTransferVm.buttonDisabled = false
    createTransferVm.isFeedback = currentUser.isFeedback
    createTransferVm.dt_start = $cookies.get('wp_start')
    createTransferVm.dt_end = $cookies.get('wp_end')

    // METHODS
    createTransferVm.hasError = hasError
    createTransferVm.showErrorMessages = showErrorMessages
    createTransferVm.addTransfer = addTransfer
    createTransferVm.validateForm = validateForm
    createTransferVm.validateCheklistPeriods = validateCheklistPeriods
    createTransferVm.funSelectedPeriod = funSelectedPeriod
    createTransferVm.startDateChange = startDateChange
    createTransferVm.confirmTransferAction = confirmTransferAction
    createTransferVm.addOrEditTransfer = addOrEditTransfer
    createTransferVm.close = close
    createTransferVm.cleanRangeType = cleanRangeType

    createTransferVm.updateRangeType = (val) => {
      createTransferVm.rangeType = val
      createTransferVm.periodsArray = []
      createTransferVm.startDate = null
      createTransferVm.endDate = null
    }
    createTransferVm.updateRangeData = (val) => {
      createTransferVm.periodsArray = val['periods']
      createTransferVm.startDate = val['dates'][0]
      createTransferVm.endDate = val['dates'][1]
    }

    activate()

    function activate () {
      if (createTransferVm.isEditing) {
        createTransferVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId
        createTransferVm.activityId = GlobalConfig.minorActivityId.transfer
        createTransferVm.createOrEdit = 'Editar'
        createTransferVm.createOrEditMV = texts.editDialog
        createTransferVm.textCreateOrEdit = texts.modified
        getDataTransfers()
      }

      WorkPlanSrv.getDataFormTransferResults.getList(post).$promise.then(
        dataReturn => {
          if (dataReturn.status) {
            loadData(dataReturn)
          } else {
            console.log('Comunications problem')
          }
        },
        data => {
          console.log(dataReturn)
        }
      )
    }

    function loadData (data) {
      createTransferVm.listResultsType = data.listTransferResults.items
      createTransferVm.typePeriod = data.listPeriods.fulfillmentValue
    }

    function hasError (input) {
      if (input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    function showErrorMessages (input) {
      return input.$dirty || input.$touched
    }

    function addTransfer (isExecution) {
      let origin = GlobalConfig.activityTypeId.originActivityPlanning
      if (isExecution) {
        origin = GlobalConfig.activityTypeId.originActivityExecution
      }
      createJson(origin)
    }

    function validateForm (form) {
      return form.$invalid ||
             createTransferVm.validateCheklistPeriods()
    }

    function validateCheklistPeriods () {
      return (createTransferVm.rangeType == 1 ? createTransferVm.periodsArray.length < 1 : false)
    }

    function funSelectedPeriod (period, checked) {
      if (checked) {
        if (!createTransferVm.periodsArray.includes(period.periodId)) {
          createTransferVm.periodsArray.push(period.periodId)
        }
      } else {
        let index = createTransferVm.periodsArray.indexOf(period.periodId)
        if (index != -1) {
          createTransferVm.periodsArray.splice(index, 1)
        }
      }
      createTransferVm.isTouchedPeriods = true
    }

    function startDateChange () {
      let m = moment(createTransferVm.startDate)
      createTransferVm.minEndDate = m.isValid() ? m/*.add(1, 'days')*/.toDate() : null
    }

    function createJson (origin) {
      var transfer = {
        teacherId: post.teacherId,
        workplanId: post.workplanId,
        activityId: GlobalConfig.minorActivityId.transfer,
        name: createTransferVm.title,
        description: createTransferVm.description,
        hoursPlanning: createTransferVm.plannedHours,
        isNotification: createTransferVm.notification,
        itemTypeResult: createTransferVm.resultsType,
        timeRangeTypeId: createTransferVm.rangeType,
        origin: origin,
        isFeedbackActivity: createTransferVm.isFeedback
      }

      if (createTransferVm.isEditing) { transfer.workplanTeacherActivityId = createTransferVm.workplanTeacherActivityId }

      if (parseInt(createTransferVm.rangeType) === GlobalConfig.periods.rangeType) {
        var arrayPeriod = []
        for (var index in createTransferVm.periodsArray) {
          var temp = {
            periodId: createTransferVm.periodsArray[index]
          }
          arrayPeriod.push(temp)
        }
        transfer.periods = arrayPeriod
      } else {
        transfer.startDate = createTransferVm.startDate
        transfer.endDate = createTransferVm.endDate
      }
      addOrEditTransfer(transfer)
    }

    function addOrEditTransfer (transfer) {
      createTransferVm.buttonDisabled = true
      WorkPlanSrv.addTransferResult.save(transfer).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          confirmTransferAction()
        } else {
          createTransferVm.buttonDisabled = false
          console.log('Communication error')
        }
      }, function (data) {
        console.log(data)
      })
    }

    function confirmTransferAction () {
      let header = {
        createOrEdit: createTransferVm.createOrEditMV,
        textCreateOrEdit: createTransferVm.textCreateOrEdit,
        itemName: createTransferVm.title,
        nameModal: texts.modalTypeName.resultsTransfer,
        modalType: texts.modalTypeId.resultsTransfer
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { })
    }

    function getDataTransfers () {
      let post = {
        workplanTeacherActivityId: parseInt(createTransferVm.workplanTeacherActivityId),
        activityId: parseInt(createTransferVm.activityId)
      }
      WorkPlanSrv.getTransferResultsByActivityId.get(post).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          setValues(dataReturn.data)
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {

      })
    }

    function setValues (transfer) {
      createTransferVm.title = transfer.name
      createTransferVm.description = transfer.description
      createTransferVm.plannedHours = transfer.hoursPlanned
      createTransferVm.resultsType = transfer.itemResultsId
      createTransferVm.rangeType = transfer.timeRangeTypeId

      let m = moment(transfer.startDate, 'YYYY-MM-DD')
      createTransferVm.dt_start = m.isValid() ? m.toDate() : null

      m = moment(transfer.endDate, 'YYYY-MM-DD')
      createTransferVm.dt_end = m.isValid() ? m.toDate() : null

      createTransferVm.periodsArray = []
      createTransferVm.selectedTypePeriod = {}
      if (transfer.isNotification == 1) {
        createTransferVm.notification = true
      }

      if (createTransferVm.rangeType == GlobalConfig.periods.rangeType) {
        var splits = transfer.periodId.split(',')
        for (var i = 0; i < splits.length; i++) {
          var valor = splits[i]
          createTransferVm.periodsArray.push(parseInt(valor))
          createTransferVm.selectedTypePeriod[valor] = true
        }
      }

      if (transfer.startDate) {
        var startDateNew = moment(transfer.startDate, 'YYYY-MM-DD').toDate()
        if (startDateNew <= moment().toDate()) {
          createTransferVm.minStartDate = moment(transfer.startDate, 'YYYY-MM-DD').toDate()
        }
        startDateChange()
      }

      createTransferVm.isEditing = true
    }

    function cleanRangeType () {
      if (parseInt(createTransferVm.rangeType) == GlobalConfig.periods.rangeType) {
        createTransferVm.startDate = null
        createTransferVm.endDate = null
      } else {
        createTransferVm.periodsArray = []
        createTransferVm.selectedTypePeriod = null
      }
    }

    function close () {
      return $mdDialog.hide()
    }
  }// FIN DEL CONSTRUCTOR
  preventInput (event) {
    var vKey = 86
    if (event.keyCode == vKey) {
      event.preventDefault()
    }
    return
  }
}
CreateResultsTransferCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$cookies', 'WorkPlanSrv', 'WorkPlanModalSrv', '$stateParams', 'WorkPlanIndicatorSrv', 'GlobalConfig']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/research/resultsTransfer/createResultsTransfer/createResultsTransferCtrl.js